export const LOADING_FORM_APPLICATIONS_START = "LOADING_FORM_APPLICATIONS_START";
export const LOADING_FORM_APPLICATIONS_FINISH = "LOADING_FORM_APPLICATIONS_FINISH";
export const SET_FORM_APPLICATIONS = "SET_FORM_APPLICATIONS";
export const CHANGE_FAMILY_DATA = "CHANGE_FAMILY_DATA";
export const SET_CURRENT_FORM = "SET_CURRENT_FORM";
